<div class="dialog">
  <h2>Add Corporate Domain</h2>

  <form [formGroup]="domainForm" (submit)="onSubmit()">
    <app-text-input
      [control]="domainName" type="text" [errors]="domainErrors" name="Domain" [bold]="false">
    </app-text-input>

    @if (error) {
      <div class="error-container">
        <img alt="Alert" src="/assets/default/alert.svg">
        <div class="error-message">
          @switch (error) {
            @case (CreateDomainError.DomainInUse) {
              This domain is already in use.
            }
            @case (CreateDomainError.DomainBlocked) {
              This domain has been blocked.
            }
            @case (CreateDomainError.UnexpectedFailure) {
              There seems to be a problem with adding this domain.
            }
          }
        </div>
      </div>
    }

    <div class="button-group button-group--center">
      <button type="button" class="btn btn-secondary btn-medium" (click)="onCancel()">Cancel</button>
      <button type="submit" class="btn btn-primary btn-medium" [disabled]="busy || domainForm.invalid">Submit</button>
    </div>
  </form>
</div>
